import MapboxGL from 'mapbox-gl';
import * as THREE from 'three'
import GLTFLoader from 'three-gltf-loader'
import { paramModel } from '../../interface-type';

export function createModelLayer(params: paramModel) {
    const { id, origin, model } = params
    const modelOrigin = origin;
    const modelAltitude = 0;
    const modelRotate = [Math.PI / 2, 0, 0];

    const modelAsMercatorCoordinate = MapboxGL.MercatorCoordinate.fromLngLat(
        modelOrigin,
        modelAltitude
    );

    const modelTransform = {
        translateX: modelAsMercatorCoordinate.x,
        translateY: modelAsMercatorCoordinate.y,
        translateZ: modelAsMercatorCoordinate.z,
        rotateX: modelRotate[0],
        rotateY: modelRotate[1],
        rotateZ: modelRotate[2],
        scale: modelAsMercatorCoordinate.meterInMercatorCoordinateUnits()
    };

    const layer: any = {
        id,
        type: 'custom',
        renderingMode: '3d',
        onAdd: function (map: MapboxGL.Map, gl: WebGLRenderingContext) {
            this.camera = new THREE.Camera();
            this.scene = new THREE.Scene();

            var hemiLight = new THREE.HemisphereLight(0xddeeff, 0x0f0e0d, 0.02);
            hemiLight.intensity = 50000;
            this.scene.add(hemiLight);

            var loader = new GLTFLoader();
            const setScene = (gltf: any) => { this.scene.add(gltf.scene); }
            loader.load(
                model,
                function (gltf: any) {
                    setScene(gltf)
                }.bind(this)
            );
            this.map = map;

            this.renderer = new THREE.WebGLRenderer({
                canvas: map.getCanvas(),
                context: gl,
                antialias: true
            });

            this.renderer.autoClear = false;
        },
        render: function (gl: WebGLRenderingContext, matrix: number[]) {
            var rotationX = new THREE.Matrix4().makeRotationAxis(
                new THREE.Vector3(1, 0, 0),
                modelTransform.rotateX
            );
            var rotationY = new THREE.Matrix4().makeRotationAxis(
                new THREE.Vector3(0, 1, 0),
                modelTransform.rotateY
            );
            var rotationZ = new THREE.Matrix4().makeRotationAxis(
                new THREE.Vector3(0, 0, 1),
                modelTransform.rotateZ
            );

            var m = new THREE.Matrix4().fromArray(matrix);
            var l = new THREE.Matrix4()
                .makeTranslation(
                    modelTransform.translateX,
                    modelTransform.translateY,
                    modelTransform.translateZ ? modelTransform.translateZ : 0
                )
                .scale(
                    new THREE.Vector3(
                        modelTransform.scale,
                        -modelTransform.scale,
                        modelTransform.scale
                    )
                )
                .multiply(rotationX)
                .multiply(rotationY)
                .multiply(rotationZ);

            this.camera.projectionMatrix = m.multiply(l);
            this.renderer.state.reset();
            this.renderer.toneMappingExposure = Math.pow(0.12, 5.0);
            this.renderer.shadowMap.enabled = true;
            this.renderer.render(this.scene, this.camera);
            this.map.triggerRepaint();
            return gl
        }
    }
    return layer
}